import configureSentry from '~lib/frontend/api/sentry';

export const setupSentry = (userId: string, configFlags: string[]) => {
	if (configFlags.includes('web_sentry_reporting'))
		configureSentry('website', 'https://d333f5d18e7c4a8eb26a7f4c4a7ab413@o396584.ingest.sentry.io/5250090', userId);
};
